import { useContext } from 'react';

import {
  type ParentPanelContextProps,
  ParentPanelContext,
} from '../contexts/ParentPanelContext.js';

/**
 * Internal hook wrapper for accessing the PanelsContext.
 * @internal
 */
export const useParentPanelContext = (): ParentPanelContextProps => {
  return useContext(ParentPanelContext);
};
